
export const stringIncludes = (s, q) => s?.toLowerCase().includes(q);
